import { Affiliate } from "./affiliate.types";
import { Plan } from "./payment.types";
import { Attachment, GeoLocation } from "./shared.types";

export enum UserRole {
  ALPHA = "alpha",
  MUSE = "muse",
}
export enum UserStatus {
  NOT_ONBOARDED = "not-onboarded",
  PENDING = "pending",
  NOT_FINISHED_PROFILE = "not-finished-profile",
  INACTIVE = "inactive",
  ACTIVE = "active",
  REJECTED = "rejected",
}
export type UserSocialLinks = {
  instagram: string;
};
export type UserSubscription = {
  availableTo: string;
  lastPaidAt: string;
  plan: Plan;
  product: {
    price: number;
  };
};
export enum UserReferralRequestStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}
export type UserReferralRequest = {
  id: string;
  status: UserReferralRequestStatus;
  referral: User;
  referrer: User;
  createdAt: string;
};
export type UserAccomplishment = {
  description: string;
  link: string;
};
export type UserVisit = {
  country: string;
  label: string;
  city?: string;
  state?: string;
};

// All fields except id can be optional due to "isDeleted", especially in chats.
export type User = {
  id: string;
  email: string;
  role: UserRole;
  status: UserStatus;
  firstName: string;
  lastName: string;
  lastSeen: string;
  createdAt: string;
  phoneNumber: string;
  dateOfBirth: string;
  remainingInvitesCount: number;
  locationOrigin: GeoLocation;
  locationResidence: GeoLocation;
  hasInfiniteFreeTrial: boolean | null;
  freeTrialEndDate?: string;
  visit?: UserVisit;
  referrer?: User;
  affiliate?: Affiliate;
  occupation?: string;
  vettingNote?: string;
  locationWorkplace?: string;
  accomplishments?: UserAccomplishment[];
  referralRequests?: UserReferralRequest[];
  profileImage?: Attachment;
  verificationSelfie?: Attachment;
  photos?: Attachment[];
  completedOnboardingAt?: string;
  socialLinks?: UserSocialLinks;
  subscription?: UserSubscription;
  isDeleted?: boolean;
};
